import { useState } from "react";
import { Navigate } from "react-router-dom";
import { MemberReview } from "@/components/admin/MemberReview";
import HomeworkReviewList from "@/components/admin/HomeworkReviewList";
import CoachGroupTable from "@/components/admin/CoachGroupTable";
import { useCoaches } from "@/hooks/useCoaches";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";
import laurel from "@/assets/coach/laurel.webp";

const TABS = { group: "Group", members: "Member progress", homework: "Homework" } as const;

export default function CoachRoom() {
  const { user } = useAuth();
  const { data, isLoading } = useCoaches();
  const [tab, setTab] = useState<keyof typeof TABS>("group");
  if (isLoading) return null;
  if (!user || !data?.has(user.id)) return <Navigate to="/dashboard" replace />;
  return (
    <div className="greek-key-frame min-h-screen w-full overflow-x-hidden bg-background px-5 pb-16 pt-12">
      <div className="greek-key-top absolute left-[6px] right-[6px] top-[10px]" aria-hidden="true" />
      <div className="mb-6 text-center">
        <img src={laurel} alt="" width={120} height={80} className="mx-auto mb-1 mt-6 h-14 w-auto" />
        <h1 className="font-display text-4xl text-foreground">Coach's Room</h1>
        <p className="mt-2 text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Discipline builds freedom</p>
      </div>
      <div className="mb-5 flex flex-wrap justify-center gap-2">
        {(Object.keys(TABS) as (keyof typeof TABS)[]).map((t) => (
          <button key={t} onClick={() => setTab(t)} className={cn("h-9 rounded-md border px-4 text-sm", tab === t ? "border-gold bg-gold/15" : "border-border")}>
            {TABS[t]}
          </button>
        ))}
      </div>
      {tab === "group" ? <CoachGroupTable coachMode /> : tab === "members" ? <MemberReview coachMode /> : <HomeworkReviewList />}
      <div className="mt-10 text-center font-serif text-xs italic uppercase tracking-[0.25em] text-muted-foreground">
        <p>Better men</p><p>build a brighter tomorrow</p>
        <div className="mx-auto mt-2 h-px w-12 bg-gold" />
      </div>
    </div>
  );
}
